import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("La nueva contraseña debe tener al menos 8 caracteres"); return; }
    if (next !== confirm) { toast.error("Las contraseñas no coinciden"); return; }
    setBusy(true);
    try {
      await api.changePassword(current, next);
      toast.success("Contraseña actualizada");
      onClose();
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Error al cambiar la contraseña");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal p-6" style={{ maxWidth: 440 }}>
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-bold text-lg">Cambiar mi contraseña</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700 text-2xl">✕</button>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label">Contraseña actual</label>
            <input className="input" type="password" required value={current}
                   onChange={(e) => setCurrent(e.target.value)}
                   data-testid="pw-current"/>
          </div>
          <div>
            <label className="label">Nueva contraseña (mín. 8)</label>
            <input className="input" type="password" required minLength={8} value={next}
                   onChange={(e) => setNext(e.target.value)}
                   data-testid="pw-new"/>
          </div>
          <div>
            <label className="label">Confirmar nueva contraseña</label>
            <input className="input" type="password" required minLength={8} value={confirm}
                   onChange={(e) => setConfirm(e.target.value)}
                   data-testid="pw-confirm"/>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={busy} data-testid="pw-save">
              {busy ? "Guardando..." : "Actualizar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
